module.exports = __webpack_public_path__ + "static/img/mobile_wx.8ed2351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_wx.png
// module id = Ka65
// module chunks = 1